// css
import '../AllOffers/allOffers.css'
import '../AllOffers/roadMap.css';
// 
import { useState } from 'react';
import { Link } from 'react-router-dom';
import magnifineImg from 'assets/Images/icons/magnifine.png';
import searchDocImg from 'assets/Images/icons/searchDoc.png';
import cartConfirm from 'assets/Images/icons/cartConfirm.png';
import enjoyPeopleImg from 'assets/Images/icons/enjoyPeople.png';
import sec1Img from 'assets/Images/bg/enjoy_time.jpg'
import sec2Img from 'assets/Images/bg/all-offers-sec2.jpg'
import sec3Img from "assets/Images/bg/all-offers-sec3.jpg";
// import calendar_oulinedImg from 'assets/Images/icons/calendar_oulined.png'
import { PlaceOutlined } from '@material-ui/icons'
import CustomModel from "Utills/Model/CustomModel"
import { DateRangePicker } from "react-date-range";
// import Moment from 'moment';
import { ClickAwayListener } from "@material-ui/core"
import { Slide, Fade } from "react-reveal";
import Reveal from "react-reveal/Reveal";
// 
import fbIcon from "assets/Images/icons/facebook.svg";
import instaIcon from "assets/Images/icons/insta.svg";
// 
import island1 from "assets/Images/bg/mykonos.jpg";
import island2 from "assets/Images/bg/Rectangle 21.jpg";
import island3 from "assets/Images/bg/island3.png";
import island4 from "assets/Images/bg/island4.jpg";
import island5 from "assets/Images/bg/island5.png";
// 
import search_for_iten from "assets/Images/bg/itineraries.jpg";

// THIS IS A ALL OFFERS PAGE
const AllOffers = () => {
    // form data state
    const [formData, setFormData] = useState({ flexible: false, place: "" })
    const [errors, setErrors] = useState({ place: { invalid: false, msg: "" } })
    const [openCalendar, setOpenCalendar] = useState(false);
    const [dates, setDates] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection',
        },
    ]);

    // static cities for dropdown
    let cities = [
        { name: "Athens", id: 0 },
        { name: "Mykonos", id: 1 },
        { name: "Corfu", id: 2 },
        { name: "Lefkada", id: 3 },
        { name: "Tinos", id: 4 },
    ];
    const [locationModal, setLocationModal] = useState(false);
    // 
    // console.log(formData?.place)
    return (
        <main className="allOffers-page">
            {/* ********************************** */}
            {/* ============= start ==============  */}
            <section className="allOffers-page-top overflow-hidden position-relative">
                <div className="all-offers-head text-white">
                    <Slide bottom>
                        {/* <h1>Customised Itineraries tailored to your needs<br /></h1> */}
                        <h1>The easiest way to book a yacht<br /></h1>
                        <p>
                        Please choose 1 option to continue
                        </p>
                        {/* <p>
                            Experience bespoke yacht voyages across Greece.
                        </p> */}
                    </Slide>
                </div>
                
                <div className="all-offers-page-main-wrapper">
                    <Slide bottom>
                        <form onSubmit={(e) => { e.preventDefault(); }} action="" className="text-center">
                            <div className="all-offer-page-top-form d-flex align-items-md-start justify-content-center py-md-5 py-4">
                                <ClickAwayListener
                                    onClickAway={() => setLocationModal(false)}
                                >
                                    <div className="left-side-choose-city d-flex align-items-center justify-content-start">
                                        <span className="text-sec"><PlaceOutlined /></span>
                                        <div onClick={() => setLocationModal(!locationModal)} className={`select_departure_location d-flex justify-content-start align-items-center ${locationModal ? 'openedLocationModal' : ""}`}>
                                            <span>{formData?.flexible ? "All Locations" : formData?.place?.length > 0 ? formData?.place : 'Choose your departure location'}</span>
                                            <svg width="15" height="8" viewBox="0 0 15 8" fill="none">
                                                <path d="M0.612998 0.206748C0.863602 -0.0438557 1.25576 -0.0666378 1.5321 0.138402L1.61127 0.206748L7.70037 6.29553L13.7895 0.206748C14.0401 -0.0438557 14.4322 -0.0666378 14.7086 0.138402L14.7877 0.206748C15.0383 0.457352 15.0611 0.849506 14.8561 1.12585L14.7877 1.20502L8.1995 7.79325C7.9489 8.04386 7.55674 8.06664 7.2804 7.8616L7.20123 7.79325L0.612998 1.20502C0.337334 0.929352 0.337334 0.482412 0.612998 0.206748Z" fill="#1A4D6D" />
                                            </svg>
                                        </div>
                                        <div className={`select_departure_location_modal ${locationModal ? 'openedLocationModal' : ''}`}>
                                            <h5>Greece</h5>
                                            {cities?.map((v, i) => (
                                                <p key={i} className="" onClick={() => {
                                                    setFormData({ ...formData, place: cities[v?.id]?.name, flexible: false });
                                                    setErrors({ place: { invalid: false, msg: "" } });
                                                    setLocationModal(false);
                                                }}>
                                                    {v?.name}
                                                </p>
                                            ))}
                                        </div>

                                        {/* <div className="cs-select-box ">
                                    <div className="cs-select">
                                        <select onChange={(e) => { {setFormData({ ...formData, place: cities[e.target.value]?.name }); setErrors({ place: { invalid: false, msg: "" } })} }} name="" id="" className="text-sec">
                                            <option value="" selected disabled>Choose your departure location</option>
                                            <optgroup label="Greece">
                                                {cities.map((city, i) => {
                                                    return (
                                                        <option key={i} value={city.id}>{city.name}</option>
                                                    )
                                                })}
                                            </optgroup>
                                        </select>
                                    </div>
                                </div> */}

                                    </div>
                                </ClickAwayListener>
                                <div className="right-side-btns-box">
                                    {/* <div className="all-offers-selected-date-input">
                                    <label className="cursor-pointer user-select-none" onClick={() => setOpenCalendar(true)} htmlFor="dateof"><img src={calendar_oulinedImg} alt="" /></label>
                                    <span
                                        className="cursor-pointer user-select-none"
                                        onClick={() => setOpenCalendar(true)}
                                        id="dateof"
                                    >
                                        {dates[0] && dates[0]?.startDate && dates[0]?.endDate ?
                                            <>
                                                {Moment(dates[0]?.startDate?.toString()).format("MMM Do YYYY")}
                                                <div>- to -</div>
                                                {Moment(dates[0]?.endDate?.toString()).format("MMM Do YYYY")}
                                            </>
                                            : 'mm dd yyyy'
                                        }
                                    </span>
                                </div> */}
                                    <div className="im-flexible-box d-flex align-items-center justify-content-start">
                                        <div className="cs-switch-container d-flex align-items-center justify-content-start">
                                            <label className="cs-switch m-0" htmlFor="checkbox1">
                                                <input checked={formData.flexible}
                                                    onChange={(e) => {
                                                        setFormData({ ...formData, flexible: e.target.checked });
                                                        setErrors({ place: { invalid: false, msg: "" } })
                                                    }
                                                    }
                                                    className="switch-checkbox m-0" type="checkbox" id="checkbox1" />
                                                <div className="cs-switch-slider switch-round"></div>
                                            </label>
                                        </div>
                                        <span className="text-pr px-2 fw-bold">I'm flexible</span>
                                    </div>
                                </div>

                            </div>
                            {errors?.place?.invalid &&
                                <h5 className="text-warning">{errors?.place?.msg}</h5>}
                            {formData?.flexible ?
                                <Link to={`/search/All-locations/flexible`} type='submit' className="avail-offer-btn-all-offers text-white">Search Itineraries</Link>
                                :
                                (formData?.place?.length > 0 ?
                                    <Link to={`/search/${formData?.place?.replace(/\s/g, '-') || "All-locations"}/${formData?.flexible ? "flexible" : "nonFlexible"}`} type='submit' className="avail-offer-btn-all-offers text-white">Search Itineraries</Link>
                                    :
                                    <button className="avail-offer-btn-all-offers text-white"
                                        onClick={() => { setErrors({ place: { invalid: true, msg: "Please select your departure location first." } }) }}
                                    >Search Itineraries</button>
                                )
                            }
                        </form>
                    </Slide>
                </div>
                <Slide bottom>
                    <h5 className="mb-5 text-center text-white fw-light pb-4 all_offers_hero_botm_para">
                        Choose from a wide range of eclectic yachts and start your journey
                    </h5>
                </Slide>
                {/* ===== */}
                <div className="footer-socials-wraps all_offers_page_socials">
                    <a href="https://www.facebook.com/Cyan-115485296918323" target="_blank" rel="noopener noreferrer"><img src={fbIcon} alt="" /></a>
                    {/* <a href="/" target="_blank" rel="noopener noreferrer"><img src={twitterIcon} alt="" /></a> */}
                    <a href="https://www.instagram.com/thecyangroup/" target="_blank" rel="noopener noreferrer"><img src={instaIcon} alt="" /></a>
                </div>
            </section>
            {/* ============ end ================= */}

            {/* ********************************** */}
            {/* Calendar Model */}
            <CustomModel
                openPopup={openCalendar}
                setOpenPopup={setOpenCalendar}
            >
                <div className="date_menu cs_cal">
                    <div className="intradaycalender">
                        <DateRangePicker
                            ranges={dates}
                            onChange={(item) => {
                                setDates([item.selection]);
                            }}
                            // selectsStart={true}
                            inline={true}
                        />
                    </div>
                </div>
            </CustomModel>
            {/*========== end ========== */}
            {/* ********************************** */}
        </main>
    )
}

export default AllOffers;

const GripTOpCard = ({ link, heading, body, img, type }) => {
    return (
        <Link to={link} className={`${type === "top" ? "top_cards" : "bottom_cards"} p-4 d-flex flex-column`}>
            <Reveal
                duration="500"
                effect="withanimate">
                <img src={img} alt="" />
            </Reveal>
                <h3>{heading}</h3>
                <p className="mt-auto">
                    {body} &nbsp;
                    <svg width="31" height="16" viewBox="0 0 31 16" fill="none">
                        <path d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z" fill="white" />
                    </svg>
                </p>
        </Link>
    )
}

// {/* <div className="cs_container mt-md-5 mb-md-4 mb-3">
//                 <div className="row py-md-4 py-3">
//                     <div className="col-12 ">
//                         <div className="our-story-head center-head-line">
//                             <Fade>
//                                 <h2 className="m-0 mx-auto py-2">Booking beyond imagination.</h2>
//                             </Fade>
//                         </div>
//                     </div>
//                     <div className="col-md-8 mx-auto my-3">
//                         <Fade bottom>
//                             <p className="text-sec text-center">
//                                 We know the yachting market inside out.  Combining our deep knowledge of yachting with our passion for tourism and technology, we are dedicated in creating the finest and most powerful boat booking platform.
//                             </p>
//                         </Fade>
//                     </div>
//                 </div>
//             </div> */}